import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/ico_complection.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("결제 실패")
const _hoisted_3 = { class: "order_completion" }
const _hoisted_4 = { class: "order_completion_area" }
const _hoisted_5 = { class: "box_completion" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "img_area" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("strong", { class: "completion_tit" }, "주문 실패", -1)
const _hoisted_8 = { class: "desc" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("주문에 실패했습니다.")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode("span", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createTextVNode(_toDisplayString(this.remainingTime) + "초 후에 상품주문 페이지로 이동합니다.", 1)
          ])
        ])
      ])
    ])
  ], 2))
}